"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useDataStore = useDataStore;
exports["default"] = exports.DATA_STORE_PATHS = void 0;

var _getIterator2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/get-iterator"));

var _iterator2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol/iterator"));

var _symbol = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/from"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _config = _interopRequireDefault(require("../../../targets/cord_sanofi/config.js"));

var _AppNativeStorage = _interopRequireDefault(require("../../utils/AppNativeStorage"));

var _TimeoutHelper = require("../../helpers/TimeoutHelper");

var _ArrayHelper = require("../../helpers/ArrayHelper");

var _HttpRequest = require("../../utils/HttpRequest");

var _RegisterInstance = _interopRequireDefault(require("../Services/RegisterInstance"));

var _BuildConstants = require("../../utils/BuildConstants");

var _DeviceInfoHelper = _interopRequireDefault(require("../../helpers/DeviceInfoHelper"));

var _DataMigrator = require("./DataMigrator");

var _ResumeSuspendListeners = require("../../helpers/ResumeSuspendListeners");

var _GenericStore2 = _interopRequireDefault(require("./GenericStore"));

var _DataStorePaths = require("./DataStorePaths");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof _symbol["default"] === "undefined" || o[_iterator2["default"]] == null) { if ((0, _isArray["default"])(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = (0, _getIterator2["default"])(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return (0, _from["default"])(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DATA_STORE_PATHS = _DataStorePaths.DATA_STORE_PATHS;
exports.DATA_STORE_PATHS = DATA_STORE_PATHS;

var DataStore = /*#__PURE__*/function (_GenericStore) {
  (0, _inherits2["default"])(DataStore, _GenericStore);

  var _super = _createSuper(DataStore);

  function DataStore() {
    var _this;

    (0, _classCallCheck2["default"])(this, DataStore);
    _this = _super.call(this);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "sendClientStoreToWebhook", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this._sendStateChangeToWebhook(DATA_STORE_PATHS.CLIENT, _this.state.data.client);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    _this.persistentData = _this._getDefaultData();
    _this.state = {
      data: _this._getDefaultData(),
      initialized: false
    };
    _this.migrationDone = false;
    _this.writeOrder = [];
    _this.sendOrder = [];
    _this.changeListeners = [];
    _this.onShowPresencesListeners = [];
    _this.sendPublicDataStoreToServerOnOnline = false;
    _this.sendClientDataStoreToServerOnOnline = false;
    (0, _ResumeSuspendListeners.addOnResumeListener)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this.sendPublicDataStoreToServerOnOnline && _DeviceInfoHelper["default"].isOnline())) {
                _context2.next = 4;
                break;
              }

              _this.sendPublicDataStoreToServerOnOnline = false;
              _context2.next = 4;
              return _this._sendStateChangeToWebhook(DATA_STORE_PATHS.PUBLIC, _this._makeCopy(_this.persistentData)[DATA_STORE_PATHS.PUBLIC]);

            case 4:
              if (!(_this.sendClientDataStoreToServerOnOnline && _DeviceInfoHelper["default"].isOnline())) {
                _context2.next = 8;
                break;
              }

              _this.sendClientDataStoreToServerOnOnline = false;
              _context2.next = 8;
              return _this._sendStateChangeToWebhook(DATA_STORE_PATHS.CLIENT, _this._makeCopy(_this.persistentData)[DATA_STORE_PATHS.CLIENT]);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _this.initOnlineListenerDeferred();

    return _this;
  }

  (0, _createClass2["default"])(DataStore, [{
    key: "initOnlineListenerDeferred",
    value: function initOnlineListenerDeferred() {
      var _this2 = this;

      setTimeout(function () {
        _DeviceInfoHelper["default"].addOnlineListener( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
          return _regenerator["default"].wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!(_this2.sendPublicDataStoreToServerOnOnline && !_DeviceInfoHelper["default"].isSuspended())) {
                    _context3.next = 4;
                    break;
                  }

                  _this2.sendPublicDataStoreToServerOnOnline = false;
                  _context3.next = 4;
                  return _this2._sendStateChangeToWebhook(DATA_STORE_PATHS.PUBLIC, _this2._makeCopy(_this2.persistentData)[DATA_STORE_PATHS.PUBLIC]);

                case 4:
                  if (!(_this2.sendClientDataStoreToServerOnOnline && _DeviceInfoHelper["default"].isOnline())) {
                    _context3.next = 8;
                    break;
                  }

                  _this2.sendClientDataStoreToServerOnOnline = false;
                  _context3.next = 8;
                  return _this2._sendStateChangeToWebhook(DATA_STORE_PATHS.CLIENT, _this2._makeCopy(_this2.persistentData)[DATA_STORE_PATHS.CLIENT]);

                case 8:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        })));
      }, 100);
    }
  }, {
    key: "_getDefaultData",
    value: function _getDefaultData() {
      return {
        "public": {},
        // bi-directional sync from and to server (server wins in case of conflict)
        server: {},
        // uni-directional sync FROM server TO device
        client: {},
        // uni-directional sync FROM device TO server
        "private": {} // no sync

      };
    }
  }, {
    key: "_getElementForPath",
    value: function _getElementForPath(pathParts, dataObject) {
      var autoInitObjects = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      // noinspection UnnecessaryLocalVariableJS
      var element = pathParts.reduce(function (acc, val, index) {
        if (!acc) {
          return null;
        }

        if (!acc[val]) {
          if (!_DataMigrator.isInMigrationMode && index < 1) {
            return null; // no creation on first level!
          }

          if (autoInitObjects || index < pathParts.length - 1) {
            acc[val] = {};
          }
        }

        return acc[val];
      }, dataObject);
      return element;
    }
  }, {
    key: "_pathExists",
    value: function _pathExists() {
      var pathParts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 ? arguments[1] : undefined;
      var currentObject = data;
      return pathParts.every(function (pathPart) {
        if (pathPart in currentObject) {
          currentObject = currentObject[pathPart];
          return true;
        }

        return false;
      });
    }
  }, {
    key: "_makeCopy",
    value: function _makeCopy(json) {
      if (json && _config["default"].storeDeepCopy) {
        return JSON.parse((0, _stringify["default"])(json));
      }

      return json;
    }
  }, {
    key: "_sendStateChangeToWebhook",
    value: function () {
      var _sendStateChangeToWebhook2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(path, data) {
        var isRetry,
            callbackWhenStoreSuccesfullySent,
            releaseFn,
            token,
            _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                isRetry = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : false;
                callbackWhenStoreSuccesfullySent = _args4.length > 3 ? _args4[3] : undefined;

                if (!_config["default"].onDataStorePublicDataChangeWebhook) {
                  _context4.next = 34;
                  break;
                }

                if (!(_config["default"].sendPublicDataStoreOnlyIfLoggedIn && path.startsWith(DATA_STORE_PATHS.PUBLIC) && !_config["default"].isLoggedIn(data))) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return");

              case 5:
                _context4.next = 7;
                return this.waitForWriteTurn(this.sendOrder);

              case 7:
                releaseFn = _context4.sent;

                if (!data) {
                  _context4.next = 33;
                  break;
                }

                console.log("Stores - sending data store for path ".concat(path, "/* to ").concat(_BuildConstants.AUTH_HOST, "/").concat(_config["default"].onDataStorePublicDataChangeWebhook), data);
                _context4.prev = 10;
                _context4.next = 13;
                return _RegisterInstance["default"].getAccessToken('dataStore:write');

              case 13:
                token = _context4.sent;
                _context4.next = 16;
                return (0, _HttpRequest.httpPostJsonEncoded)(_BuildConstants.AUTH_HOST + '/' + _config["default"].onDataStorePublicDataChangeWebhook, {
                  path: path,
                  value: data
                }, null, 60000, 2, 'Bearer ' + token, function () {
                  releaseFn();
                }, null, false);

              case 16:
                callbackWhenStoreSuccesfullySent ? callbackWhenStoreSuccesfullySent() : null;
                releaseFn();
                _context4.next = 31;
                break;

              case 20:
                _context4.prev = 20;
                _context4.t0 = _context4["catch"](10);
                console.error('error sending data store to server. Ignore if device is offline', _context4.t0);

                if (!(!isRetry && _context4.t0.message && (_context4.t0.message === 'ERROR_HTTP_STATUS_403' || _context4.t0.message === 'ERROR_HTTP_STATUS_401'))) {
                  _context4.next = 30;
                  break;
                }

                _context4.next = 26;
                return _RegisterInstance["default"].forceRenewAccessToken();

              case 26:
                releaseFn();
                return _context4.abrupt("return", this._sendStateChangeToWebhook(path, data, true, callbackWhenStoreSuccesfullySent));

              case 30:
                releaseFn();

              case 31:
                _context4.next = 34;
                break;

              case 33:
                releaseFn();

              case 34:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[10, 20]]);
      }));

      function _sendStateChangeToWebhook(_x, _x2) {
        return _sendStateChangeToWebhook2.apply(this, arguments);
      }

      return _sendStateChangeToWebhook;
    }()
  }, {
    key: "removeUnchangedValues",
    value: function removeUnchangedValues(dataToSet, dataToCompareWith) {
      var _this3 = this;

      var unchangedPaths = (0, _keys["default"])(dataToSet).filter(function (path) {
        var currentValue = _this3._getElementForPath(path.split('.'), dataToCompareWith);

        return (0, _stringify["default"])(dataToSet[path]) === (0, _stringify["default"])(currentValue);
      });

      if (unchangedPaths.length > 0) {
        var dataCopy = (0, _assign["default"])({}, dataToSet);

        var _iterator = _createForOfIteratorHelper(unchangedPaths),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var unchangedPath = _step.value;
            delete dataCopy[unchangedPath];
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return dataCopy;
      }

      return dataToSet;
    }
    /**
     * ONLY JSON and other basic (native) types are accepted! If it is not serializable with JSON.stringify() it throws
     * an exception.
     *
     * Data is always copied before saving it to the store
     */

  }, {
    key: "_setData",
    value: function () {
      var _setData2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(data) {
        var _this4 = this;

        var persistent,
            autoInitObjects,
            mergeDataForExistingPaths,
            calledFromOtherDataStore,
            callbackWhenStoreSuccesfullySent,
            releaseFn,
            startTime,
            stateDataCopy,
            persistentDataCopy,
            updatedPublic,
            updatedClient,
            dataToSet,
            inputData,
            flatten,
            inputKeys,
            finalData,
            inputDataCopy,
            persistPromise,
            endTime,
            diff,
            _args5 = arguments;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                persistent = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : true;
                autoInitObjects = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : true;
                mergeDataForExistingPaths = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : false;
                calledFromOtherDataStore = _args5.length > 4 && _args5[4] !== undefined ? _args5[4] : false;
                callbackWhenStoreSuccesfullySent = _args5.length > 5 ? _args5[5] : undefined;

                // These lines is only for developing purposes
                // if (!calledFromOtherDataStore) {
                //   DataStore1._setData(data, this.persistentData, autoInitObjects, mergeDataForExistingPaths, true)
                // }
                if (this.writeOrder.length > 0) {
                  console.log('data store write queue length is', this.writeOrder.length, 'paths: ', (0, _keys["default"])(data).join(','));
                }

                _context5.next = 8;
                return this.waitForWriteTurn(this.writeOrder);

              case 8:
                releaseFn = _context5.sent;
                // console.log('Stores - onSetData', data)
                startTime = new Date(); // console.log('Stores - onSetDataBulk', bulk)
                // make copy of current state so any component can compare the last state with the upcoming one
                // note: this is only true if target.storeDeepCopy is set to true (default: true)

                stateDataCopy = this._makeCopy(this.state.data);
                persistentDataCopy = persistent ? this._makeCopy(this.persistentData) : null;
                updatedPublic = false;
                updatedClient = false;
                dataToSet = this.removeUnchangedValues(data, stateDataCopy);

                if (mergeDataForExistingPaths) {
                  // flatten data for merging
                  inputData = {};

                  flatten = function flatten(pathPrefix, data) {
                    (0, _keys["default"])(data).forEach(function (key) {
                      var path = pathPrefix ? "".concat(pathPrefix, ".").concat(key) : key;
                      var value = data[key];

                      if (value instanceof Object && !(0, _isArray["default"])(value)) {
                        flatten(path, value);
                        return;
                      }

                      inputData[path] = value;
                    });
                  };

                  flatten(null, dataToSet); // console.log('flattenend data', data, inputData)
                } else {
                  inputData = dataToSet;
                }

                inputKeys = (0, _keys["default"])(inputData);

                if (inputKeys.length === 0) {
                  console.log('No change in data store values - not setting anything. Paths are:', (0, _keys["default"])(data));
                }

                console.log('input keys to set', inputKeys);
                inputKeys.forEach(function (path) {
                  var value = inputData[path]; // if it is not serializable, this line throws an exception

                  var dataToSave = _this4._makeCopy(value);

                  var pathParts = path.split('.');

                  if (persistent) {
                    var elementPersistent = _this4._getElementForPath(pathParts.slice(0, -1), persistentDataCopy, autoInitObjects);

                    if (elementPersistent) {
                      elementPersistent[pathParts.slice(-1)] = dataToSave;
                    }

                    if (pathParts[0] === DATA_STORE_PATHS.PUBLIC) {
                      updatedPublic = true;
                    } else if (pathParts[0] === DATA_STORE_PATHS.CLIENT) {
                      updatedClient = true;
                    }
                  }
                });
                finalData = {};

                if (_config["default"].requiredFeature === 'equeoqd') {
                  // TODO Use this version for quiz apps
                  (0, _keys["default"])(inputData).forEach(function (key) {
                    finalData["data.".concat(key)] = inputData[key];
                  });
                } else {
                  // TODO Use this version where a copy is made of the inputData to correctly handle objects // for the moment: breaks quiz app, slows it down extremely
                  finalData = this.state || {};
                  inputDataCopy = this._makeCopy(inputData);
                  (0, _keys["default"])(inputDataCopy).forEach(function (key) {
                    finalData["data.".concat(key)] = inputDataCopy[key];
                  });
                }

                if (persistentDataCopy) finalData['data'] = persistentDataCopy;
                this.setState(finalData);

                if (!(persistent && persistentDataCopy)) {
                  _context5.next = 42;
                  break;
                }

                _context5.prev = 25;
                persistPromise = _AppNativeStorage["default"].saveValue(_AppNativeStorage["default"].KEYS.DATA, persistentDataCopy);

                if (!_config["default"].saveToDateStoreWaitsForPersisting) {
                  _context5.next = 32;
                  break;
                }

                _context5.next = 30;
                return persistPromise;

              case 30:
                _context5.next = 32;
                break;

              case 32:
                // put it to class member *after* being successfully saved to native storage
                // as in case of an error that error will repeat itself each time data is stored permanently
                this.persistentData = persistentDataCopy;

                if (updatedPublic) {
                  if (_DeviceInfoHelper["default"].isOnline() && !_DeviceInfoHelper["default"].isSuspended()) {
                    this._sendStateChangeToWebhook(DATA_STORE_PATHS.PUBLIC, persistentDataCopy[DATA_STORE_PATHS.PUBLIC], false, callbackWhenStoreSuccesfullySent);
                  } else {
                    this.sendPublicDataStoreToServerOnOnline = true;
                  }
                }

                if (updatedClient) {
                  if (_DeviceInfoHelper["default"].isOnline() && !_DeviceInfoHelper["default"].isSuspended()) {
                    this._sendStateChangeToWebhook(DATA_STORE_PATHS.CLIENT, persistentDataCopy[DATA_STORE_PATHS.CLIENT], false, callbackWhenStoreSuccesfullySent);
                  } else {
                    this.sendClientDataStoreToServerOnOnline = true;
                  }
                }

                _context5.next = 42;
                break;

              case 37:
                _context5.prev = 37;
                _context5.t0 = _context5["catch"](25);
                console.error('error saving data:', _context5.t0);
                releaseFn();
                return _context5.abrupt("return", _promise["default"].reject(_context5.t0));

              case 42:
                releaseFn();
                endTime = new Date();
                diff = endTime - startTime;

                if (diff > 300) {
                  console.log('set data took:', diff, 'for paths:', (0, _keys["default"])(data).join(', '));
                }

              case 46:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[25, 37]]);
      }));

      function _setData(_x3) {
        return _setData2.apply(this, arguments);
      }

      return _setData;
    }()
  }, {
    key: "loadFromServer",
    value: function () {
      var _loadFromServer = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(path) {
        var storeLocally,
            doneCallback,
            token,
            response,
            _args6 = arguments;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                storeLocally = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : true;
                doneCallback = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : null;
                console.log('loadFromServer', _config["default"], _config["default"].isLoggedIn());

                if (!_config["default"].dataStoreServerUrl) {
                  _context6.next = 29;
                  break;
                }

                if (!(_config["default"].sendPublicDataStoreOnlyIfLoggedIn && !_config["default"].isLoggedIn())) {
                  _context6.next = 6;
                  break;
                }

                return _context6.abrupt("return", _promise["default"].resolve());

              case 6:
                _context6.prev = 6;
                _context6.next = 9;
                return _RegisterInstance["default"].getAccessToken('dataStore:read');

              case 9:
                token = _context6.sent;
                console.log('starting retrieve call', new Date((0, _now["default"])()).toLocaleString());
                _context6.next = 13;
                return (0, _HttpRequest.httpGet)(_BuildConstants.AUTH_HOST + '/' + _config["default"].dataStoreServerUrl, null, null, 10000, 2, 'Bearer ' + token);

              case 13:
                response = _context6.sent;

                if (!response) {
                  _context6.next = 21;
                  break;
                }

                console.log("successfully retrieved data store for path ".concat(path, " from server"), response.data);

                if (!(storeLocally && response.data && response.data.data && response.data.data[path])) {
                  _context6.next = 19;
                  break;
                }

                _context6.next = 19;
                return this.mergeAndSetData(response.data.data);

              case 19:
                if (doneCallback) {
                  doneCallback();
                }

                return _context6.abrupt("return", _promise["default"].resolve(response.data));

              case 21:
                console.error("error retrieving data store for path ".concat(path, " from server: response doesn't contain data field"), response);
                return _context6.abrupt("return", _promise["default"].reject(new Error('no data field in response')));

              case 25:
                _context6.prev = 25;
                _context6.t0 = _context6["catch"](6);
                console.error("error retrieving data store for path ".concat(path, " from server"), _context6.t0);
                return _context6.abrupt("return", _promise["default"].reject(_context6.t0));

              case 29:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[6, 25]]);
      }));

      function loadFromServer(_x4) {
        return _loadFromServer.apply(this, arguments);
      }

      return loadFromServer;
    }()
  }, {
    key: "setState",
    value: function setState(state) {
      var _this5 = this;

      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DataStore.prototype), "setValues", this).call(this, state);
      setTimeout(function () {
        _this5.changeListeners.forEach(function (listener) {
          return listener();
        });
      });
    }
  }, {
    key: "addOnChangeListener",
    value: function addOnChangeListener(callback) {
      var _this6 = this;

      this.changeListeners.push(callback);
      return function () {
        (0, _ArrayHelper.removeElement)(_this6.changeListeners, callback);
      };
    }
    /**
     * Methods from equizzerStore
     */

  }, {
    key: "getActivatedFeatures",
    value: function getActivatedFeatures() {
      return this.state.data.activatedFeatures;
    }
  }, {
    key: "isActivatedFeature",
    value: function isActivatedFeature(featureName) {
      return this.state.data.activatedFeatures.includes(featureName);
    }
  }, {
    key: "getShowPresences",
    value: function getShowPresences() {
      return this.state.data.showPresences;
    }
    /**
     * Always returns a copy of the current DataStore object - so you can play with the object as much as you like!
     * @param path, deepCopy
     * @param calledFromDataMigrator {Boolean} This activates special behaviour.
     * @returns {*} - a deep copy of the requested object
     */

  }, {
    key: "getElementByPath",
    value: function () {
      var _getElementByPath = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(path) {
        var calledFromDataMigrator,
            pathParts,
            _args7 = arguments;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                calledFromDataMigrator = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : false;
                // console.log('getting element with path', path)
                pathParts = path.split('.');

                if (calledFromDataMigrator) {
                  _context7.next = 8;
                  break;
                }

              case 3:
                if (!(!this.migrationDone || !this.state.initialized)) {
                  _context7.next = 8;
                  break;
                }

                _context7.next = 6;
                return (0, _TimeoutHelper.timeout)(100);

              case 6:
                _context7.next = 3;
                break;

              case 8:
                // device.* was moved to private.*
                // This is kept as a kind of symbolic link to avoid changing all content *right* now
                if (!calledFromDataMigrator && pathParts.length > 0 && pathParts[0] === DATA_STORE_PATHS.DEVICE) {
                  pathParts[0] = DATA_STORE_PATHS.PRIVATE;
                }

                return _context7.abrupt("return", _promise["default"].resolve(this._makeCopy(this._getElementForPath(pathParts, this.state.data))));

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getElementByPath(_x5) {
        return _getElementByPath.apply(this, arguments);
      }

      return getElementByPath;
    }()
  }, {
    key: "getElementByPathImmediately",
    value: function getElementByPathImmediately(path) {
      // console.log('getting element immediately with path', path)
      if (!path) {
        return;
      }

      var pathParts = path.split('.'); // device.* was moved to private.*
      // This is kept as a kind of symbolic link to avoid changing all content *right* now

      if (pathParts.length > 0 && pathParts[0] === DATA_STORE_PATHS.DEVICE) {
        pathParts[0] = DATA_STORE_PATHS.PRIVATE;
      }

      return this._makeCopy(this._getElementForPath(pathParts, this.state.data));
    }
  }, {
    key: "getElementByPathInData",
    value: function getElementByPathInData(path, data) {
      var pathParts = path.split('.'); // device.* was moved to private.*
      // This is kept as a kind of symbolic link to avoid changing all content *right* now

      if (pathParts.length > 0 && pathParts[0] === DATA_STORE_PATHS.DEVICE) {
        pathParts[0] = DATA_STORE_PATHS.PRIVATE;
      }

      return this._getElementForPath(pathParts, data, false);
    }
  }, {
    key: "loadFromNativeStorage",
    value: function () {
      var _loadFromNativeStorage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
        var _this7 = this;

        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                console.log('loading data from native storage');
                _context8.prev = 1;

                if (!_config["default"].dismissDataStoreAtStart) {
                  _context8.next = 6;
                  break;
                }

                this.persistentData = this._getDefaultData();
                _context8.next = 12;
                break;

              case 6:
                _context8.next = 8;
                return _AppNativeStorage["default"].getValue(_AppNativeStorage["default"].KEYS.DATA);

              case 8:
                _context8.t0 = _context8.sent;

                if (_context8.t0) {
                  _context8.next = 11;
                  break;
                }

                _context8.t0 = this._getDefaultData();

              case 11:
                this.persistentData = _context8.t0;

              case 12:
                this.setState({
                  data: this.persistentData,
                  initialized: true
                }); // TODO: Find a better way to say when data is loaded to store

                return _context8.abrupt("return", new _promise["default"](function (resolve, reject) {
                  // eslint-disable-next-line prefer-const
                  var interval;

                  var checkIfLoaded = function checkIfLoaded() {
                    if (_this7.state.initialized) {
                      console.log('DataStore now loaded');
                      console.log('DATA: ', _this7.state);
                      clearInterval(interval);
                      resolve();
                      return;
                    }

                    console.log('DataStore not yet loaded');
                  };

                  interval = setInterval(checkIfLoaded, 100);
                }));

              case 16:
                _context8.prev = 16;
                _context8.t1 = _context8["catch"](1);
                console.log('error retrieving data from native storage. Not yet available?', _context8.t1);
                return _context8.abrupt("return", _promise["default"].reject(_context8.t1));

              case 20:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[1, 16]]);
      }));

      function loadFromNativeStorage() {
        return _loadFromNativeStorage.apply(this, arguments);
      }

      return loadFromNativeStorage;
    }()
    /**
     * ONLY JSON and other basic (native) types are accepted! If it is not serializable with JSON.stringify() it throws
     * an exception.
     *
     * Data is always copied before saving it to the store
     */
    // async setData (path, data, persistent = true, autoInitObjects = false) {
    //   const releaseFn = await this.waitForWriteTurn(this.writeOrder)
    //
    //   // console.log('Stores - onSetData', path, data)
    //
    //   while (!this.state.initialized) {
    //     await timeout(100)
    //   }
    //
    //   // if it is not serializable, this line throws an exception
    //   const dataToSave = this._makeCopy(data)
    //
    //   // make copy of current state so any component can compare the last state with the upcoming one
    //   const stateDataCopy = this._makeCopy(this.state.data)
    //
    //   const pathParts = path.split('.')
    //   const element = this._getElementForPath(pathParts.slice(0, -1), stateDataCopy, autoInitObjects)
    //
    //   if (element) {
    //     element[pathParts.slice(-1)] = dataToSave
    //   }
    //   else {
    //     console.error(`Couldn't save element for path ${path} because parent isn't existing or isn't an object`)
    //     // TODO: Shouldn't we throw an exception here?
    //   }
    //
    //   if (persistent) {
    //     const persistentDataCopy = this._makeCopy(this.persistentData)
    //     const elementPersistent = this._getElementForPath(pathParts.slice(0, -1), persistentDataCopy, autoInitObjects)
    //
    //     if (elementPersistent) {
    //       elementPersistent[pathParts.slice(-1)] = dataToSave
    //     }
    //
    //     try {
    //       await NativeStorage.saveValue(NativeStorage.KEYS.DATA, persistentDataCopy)
    //       // put it to class member *after* being successfully saved to native storage
    //       // as in case of an error that error will repeat itself each time data is stored permanently
    //       this.persistentData = persistentDataCopy
    //
    //       // console.log('send setData', persistentDataCopy[DATA_STORE_PATHS.PUBLIC])
    //
    //       if (pathParts[0] === DATA_STORE_PATHS.PUBLIC) {
    //         // console.log('really send setData')
    //         this._sendStateChangeToWebhook(DATA_STORE_PATHS.PUBLIC, persistentDataCopy[DATA_STORE_PATHS.PUBLIC])
    //       }
    //     }
    //     catch (error) {
    //       console.error('error saving data:', error)
    //       releaseFn()
    //       return Promise.reject(error)
    //     }
    //   }
    //   if (element) {
    //     this.setState({data: stateDataCopy})
    //   }
    //   releaseFn()
    //   return Promise.resolve()
    // }

    /**
     * ONLY JSON and other basic (native) types are accepted! If it is not serializable with JSON.stringify() it throws
     * an exception.
     *
     * Data is always copied before saving it to the store
     */

  }, {
    key: "setSingleData",
    value: function () {
      var _setSingleData = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(path, value) {
        var persistent,
            calledFromDataMigrator,
            callbackWhenStoreSuccesfullySent,
            data,
            _args9 = arguments;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                persistent = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : true;
                calledFromDataMigrator = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : false;
                callbackWhenStoreSuccesfullySent = _args9.length > 4 ? _args9[4] : undefined;

                if (calledFromDataMigrator) {
                  _context9.next = 9;
                  break;
                }

              case 4:
                if (!(!this.migrationDone || !this.state.initialized)) {
                  _context9.next = 9;
                  break;
                }

                _context9.next = 7;
                return (0, _TimeoutHelper.timeout)(100);

              case 7:
                _context9.next = 4;
                break;

              case 9:
                data = {};
                data[path] = value;
                return _context9.abrupt("return", this._setData(data, persistent, true, false, false, callbackWhenStoreSuccesfullySent));

              case 12:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function setSingleData(_x6, _x7) {
        return _setSingleData.apply(this, arguments);
      }

      return setSingleData;
    }()
    /**
     * ONLY JSON and other basic (native) types are accepted! If it is not serializable with JSON.stringify() it throws
     * an exception.
     *
     * Data is always copied before saving it to the store
     */

  }, {
    key: "setSingleDataIfPathExists",
    value: function () {
      var _setSingleDataIfPathExists = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(path, value) {
        var persistent,
            data,
            _args10 = arguments;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                persistent = _args10.length > 2 && _args10[2] !== undefined ? _args10[2] : true;

                if (path === DATA_STORE_PATHS.TC_HOME_REGION_CODE) {
                  console.error('setSingleDataIfPathExists', path, value, persistent);
                }

                data = {};
                data[path] = value;
                return _context10.abrupt("return", this._setData(data, persistent, false));

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function setSingleDataIfPathExists(_x8, _x9) {
        return _setSingleDataIfPathExists.apply(this, arguments);
      }

      return setSingleDataIfPathExists;
    }()
    /**
     * ONLY JSON and other basic (native) types are accepted! If it is not serializable with JSON.stringify() it throws
     * an exception.
     *
     * Data is always copied before saving it to the store
     */

  }, {
    key: "setData",
    value: function () {
      var _setData3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(data) {
        var persistent,
            _args11 = arguments;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                persistent = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : true;
                return _context11.abrupt("return", this._setData(data, persistent, true));

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function setData(_x10) {
        return _setData3.apply(this, arguments);
      }

      return setData;
    }()
  }, {
    key: "mergeAndSetData",
    value: function () {
      var _mergeAndSetData = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(data) {
        var persistent,
            _args12 = arguments;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                persistent = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : true;

                if (data) {
                  _context12.next = 3;
                  break;
                }

                return _context12.abrupt("return");

              case 3:
                return _context12.abrupt("return", this._setData(data, persistent, true, true));

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function mergeAndSetData(_x11) {
        return _mergeAndSetData.apply(this, arguments);
      }

      return mergeAndSetData;
    }()
  }, {
    key: "setDataBulk",
    value: function () {
      var _setDataBulk = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13(bulk) {
        var persistent,
            autoInitObjects,
            rows,
            data,
            _args13 = arguments;
        return _regenerator["default"].wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                persistent = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : true;
                autoInitObjects = _args13.length > 2 && _args13[2] !== undefined ? _args13[2] : true;
                // console.log('Stores - onSetDataBulk', bulk)
                rows = bulk.split('\n');
                data = {};
                rows.forEach(function (row) {
                  try {
                    var keyValue = row.split('=');

                    if (keyValue.length >= 2) {
                      var key = keyValue[0].trim();

                      if (key === DATA_STORE_PATHS.TC_HOME_REGION_CODE) {
                        console.error('setDataBulk', key, keyValue[1]);
                      }

                      data[key] = JSON.parse(keyValue[1].trim());
                    }
                  } catch (error) {
                    console.error('couldn\'t parse row', row);
                  }

                  return null;
                });
                return _context13.abrupt("return", this._setData(data, persistent, autoInitObjects));

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function setDataBulk(_x12) {
        return _setDataBulk.apply(this, arguments);
      }

      return setDataBulk;
    }()
  }, {
    key: "removeData",
    value: function () {
      var _removeData = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14(path) {
        var calledFromDataMigrator,
            releaseFn,
            pathParts,
            stateDataCopy,
            element,
            persistentDataCopy,
            elementPersistent,
            _args14 = arguments;
        return _regenerator["default"].wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                calledFromDataMigrator = _args14.length > 1 && _args14[1] !== undefined ? _args14[1] : false;
                _context14.next = 3;
                return this.waitForWriteTurn(this.writeOrder);

              case 3:
                releaseFn = _context14.sent;

                if (calledFromDataMigrator) {
                  _context14.next = 10;
                  break;
                }

              case 5:
                if (!(!this.migrationDone || !this.state.initialized)) {
                  _context14.next = 10;
                  break;
                }

                _context14.next = 8;
                return (0, _TimeoutHelper.timeout)(100);

              case 8:
                _context14.next = 5;
                break;

              case 10:
                pathParts = path.split('.');
                stateDataCopy = this._makeCopy(this.state.data);
                element = this._getElementForPath(pathParts.slice(0, -1), stateDataCopy);

                if (element) {
                  try {
                    delete element[pathParts.slice(-1)];
                  } catch (error) {
                    console.error('error removing data:', error);
                  }

                  this.setState({
                    data: stateDataCopy
                  });
                }

                persistentDataCopy = this._makeCopy(this.persistentData);
                elementPersistent = this._getElementForPath(pathParts.slice(0, -1), persistentDataCopy);

                if (!elementPersistent) {
                  _context14.next = 28;
                  break;
                }

                _context14.prev = 17;
                delete elementPersistent[pathParts.slice(-1)];
                _context14.next = 21;
                return _AppNativeStorage["default"].saveValue(_AppNativeStorage["default"].KEYS.DATA, persistentDataCopy);

              case 21:
                this.persistentData = persistentDataCopy;

                if (pathParts[0] === DATA_STORE_PATHS.PUBLIC) {
                  this._sendStateChangeToWebhook(DATA_STORE_PATHS.PUBLIC, persistentDataCopy[DATA_STORE_PATHS.PUBLIC]);
                }

                _context14.next = 28;
                break;

              case 25:
                _context14.prev = 25;
                _context14.t0 = _context14["catch"](17);
                console.error('error removing persistent data:', _context14.t0);

              case 28:
                releaseFn();
                return _context14.abrupt("return", _promise["default"].resolve());

              case 30:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[17, 25]]);
      }));

      function removeData(_x13) {
        return _removeData.apply(this, arguments);
      }

      return removeData;
    }()
  }, {
    key: "resetStore",
    value: function () {
      var _resetStore = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15() {
        var prop;
        return _regenerator["default"].wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                console.log('Stores - resetStore', (0, _stringify["default"])(this.state));

                for (prop in this.state) {
                  console.log('prop', prop);
                  delete this.state[prop];
                }

                this.setState({
                  data: this._getDefaultData(),
                  initialized: true
                });
                this.persistentData = this._getDefaultData();
                _context15.next = 6;
                return _AppNativeStorage["default"].removeValue(_AppNativeStorage["default"].KEYS.DATA);

              case 6:
                console.log('Stores - resetStore', (0, _stringify["default"])(this.state));
                return _context15.abrupt("return", _promise["default"].resolve());

              case 8:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function resetStore() {
        return _resetStore.apply(this, arguments);
      }

      return resetStore;
    }()
  }, {
    key: "waitForWriteTurn",
    value: function () {
      var _waitForWriteTurn = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee16(orderArray) {
        return _regenerator["default"].wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                return _context16.abrupt("return", new _promise["default"](function (resolve) {
                  var onReady = function onReady() {
                    resolve(function () {
                      // this is the release callback function
                      (0, _ArrayHelper.removeElementAtPosition)(orderArray, 0);

                      if (orderArray.length > 0) {
                        // trigger next waiting thread in line
                        orderArray[0]();
                      }
                    });
                  };

                  orderArray.push(function () {
                    onReady();
                  });

                  if (orderArray.length === 1) {
                    // then it's me
                    onReady();
                  }
                }));

              case 1:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));

      function waitForWriteTurn(_x14) {
        return _waitForWriteTurn.apply(this, arguments);
      }

      return waitForWriteTurn;
    }()
  }, {
    key: "pathExists",
    value: function pathExists(path) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.data;
      var pathParts = path.split('.');
      return this._pathExists(pathParts, data);
    }
    /**
     * Returns false if path does not exist OR value is different.
     *
     * If you compare a non-existing path with null the result will be false.
     */

  }, {
    key: "compare",
    value: function compare(path, value) {
      var pathExists = this.pathExists(path);
      var elementValue = this.getElementByPathImmediately(path);
      return pathExists && elementValue === value;
    }
  }, {
    key: "setMigrationDone",
    value: function setMigrationDone() {
      this.migrationDone = true;
    }
  }]);
  return DataStore;
}(_GenericStore2["default"]);
/**
 * @type DataStore
 */


var dataStore = new DataStore();
/**
 * Provide a hook.
 * Like useState it returns an array: The first value in the array is the requested value and
 * the second one is a function to set this value. Example:
 * ```
 *      const [foobar, setFoobar] = useDataStore(DATA_STORE_PATH.FOOBAR)
 *
 *      console.log(foobar)          // prints undefined
 *      await setFoobar('barfuß')
 *      console.log('foobar')        // prints 'foobar'
 * ```
 * @param path
 * @returns {Array<string|number|boolean|object|array, function>}
 */

function useDataStore(path) {
  var value = dataStore.getElementByPathImmediately(path);

  var setValue = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee17(val) {
      return _regenerator["default"].wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              return _context17.abrupt("return", dataStore.setSingleData(path, val));

            case 1:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }));

    return function setValue(_x15) {
      return _ref4.apply(this, arguments);
    };
  }();

  return [value, setValue];
}

var _default = dataStore;
exports["default"] = _default;